import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import { withStyles } from "@material-ui/core/styles";
import FormControl from '@material-ui/core/FormControl';
import { constants } from '../constants/constants';
import * as HTTPClient from '../helper/httpClient';
import { endPoints } from '../constants/endPoints';

const styles = {

    labelFocused: {},
    root: {
        minWidth: 275,
    },

    title: {
        fontSize: 14,
    },
};
class Cancellation extends React.Component {
    constructor(props) {
        super(props);
        document.title = 'Appointment cancelation'
        this.state = {
            isCancelled: false,    
            companyLogo: null,
            isCickActionDisabled: false,
            appointmentName:null,
            contactName:null,
            appoTime:null,
            slug:null,
            mounted:false,
            appoStatus:null,
        }
    }
    componentDidMount() {
        console.log(this.props);
    }
    UNSAFE_componentWillMount=()=> {
        let appointmentName = null;
        let contactName = null;
        let appoTime = null;
        let slug = null;
        let appoStatus = null;
        let tempParam =  this.props.match.params.id;

        let params = { "eventId": tempParam.split("_")[1], "encodedParams": tempParam.split("_")[0] }
        var promise = Promise.resolve(HTTPClient.getFullResponseWithoutToken(endPoints.SCHEDULER.COMPANY_LOGO, params));
      promise.then((response) => {
              if (response.status == 0) {
                  let companyLogo = response.data.logoUrl;
                  if (companyLogo == null || companyLogo == '') {
                    companyLogo = "/images/soffront_logo.png";
                }
                if (response.data.hasOwnProperty("appointmentName")) {
                    appointmentName = response.data.appointmentName;
                }
                if (response.data.hasOwnProperty("contactName")) {
                    contactName = response.data.contactName;
                }
                if (response.data.hasOwnProperty("appoTime")) {
                    appoTime = response.data.appoTime;
                }
                if (response.data.hasOwnProperty("slug")) {
                    slug = response.data.slug;
                }
                if (response.data.hasOwnProperty("appoStatus")) {
                    appoStatus = response.data.appoStatus;
                }
               this.setState({ companyLogo:companyLogo,appoTime:appoTime,appointmentName:appointmentName,contactName:contactName,slug:slug,appoStatus:appoStatus,mounted:true});
              } 
      })
    }

    clickAction = (isCancelled) => {
        let _state = this.state;
        let tempParam =  this.props.match.params.id;
        if (!this.state.isCickActionDisabled && !isCancelled) {
            let params = { "eventId": tempParam.split("_")[1], "encodedParams": tempParam.split("_")[0] }
            var promise = Promise.resolve(HTTPClient.postWithoutToken(endPoints.SCHEDULER.CANCEL_APPOINTMENT, params));
            promise.then((response) => {
                if (response.status == 0) {
                    this.setState({ isCancelled: true});
                } 
            })
        }
        else if (!this.state.isCickActionDisabled && isCancelled) {
            this.setState({ isCickActionDisabled: true});
                    let url = this.state.slug;
                    window.location.replace(url);
               
        }
    }  
    render() {
       let {companyLogo,isCancelled} = this.state;
        const { classes } = this.props;
        let buttonMarginLeft = !isCancelled ?'172px':'82px';
        let  showData = null;
        if(this.state.mounted){
            let contactName = this.state.contactName;
            let appointmentName = this.state.appointmentName;
            if(appointmentName.includes(contactName)){
                showData = this.state.appointmentName;
            }else {
                showData = this.state.contactName + ": "+this.state.appointmentName;
            }
        }
        return (
            <div className="col-md-6 col-md-offset-3" >
                <div className="col-md-10 col-md-offset-1">
                    <div >
                        <  >
                        {this.state.mounted && this.state.appoStatus!="Cancelled" &&
                            <div className='abc' style={{ width: '450px', marginTop: '11%', marginLeft: '33%' }}>
                                    <Box boxShadow={3} className='sf-login-box'>
                                        <Card className={classes.root} style={{ height: '350px' }}>  
                                            <div>
                                            <CardContent style={{ marginTop: '-10px', marginLeft: '10px' }}>
                                            <div style={{ marginTop: '10%', marginLeft: '10px' }}>
                                                    <Typography className='sf-login-Typography' color="textSecondary" align="center" style={{ fontSize: 30 }}>
                                                        < img src={companyLogo} style={{ maxWidth: '130px', maxHeight: '40px' }} />  </Typography> </div>
                                                {isCancelled ?
                                                    <Typography className='sf-login-Typography' color="textSecondary" align="center" style={{ fontSize: 24 }}>
                                                        {showData} Cancelled
                                                    </Typography>
                                                    :
                                                    <Typography className='sf-login-Typography' color="textSecondary" align="center" style={{ fontSize: 24 }}>
                                                        Cancel {showData}
                                                    </Typography>
                                                }
                                                {isCancelled ?
                                                <Typography className='sf-login-Typography' color="textSecondary" gutterBottom align="center" style={{ fontSize: 16 }}>
                                               
                                                </Typography>
                                                :
                                                <Typography className='sf-login-Typography' color="textSecondary" gutterBottom align="center" style={{ fontSize: 16,paddingTop:"7px" }}>
                                               {this.state.appoTime}
                                                </Typography>
                                                }
                                            </CardContent>
                                            <CardActions>
                                            <div style={{ textAlign: 'center' }}>
                                                <Button variant="contained" align="center" style={{ backgroundColor: '#EE5624', fontSize: 14, marginLeft: buttonMarginLeft }}
                                                    onClick={() => this.clickAction(isCancelled)}
                                                    color="primary" size="large"  >
                                                { !isCancelled ?'Cancel':'Schedule a New Appointment'}
                                                </Button>
                                            </div>
                                            </CardActions>
                                            </div>
                                        </Card>
                                    </Box>
                            </div>
    }
                            {this.state.mounted && this.state.appoStatus == "Cancelled" &&
                                <Typography className='sf-login-Typography' color="textSecondary" gutterBottom align="center" style={{ fontSize: 16, marginTop: 290,  }}>
                                    This appointment has been already Cancelled.
                                </Typography>
                            }

                        </ >
                    </div>
                </div>
            </div>
        );
    }
}
export default withStyles(styles, { withTheme: true })(Cancellation);